export const sessionsList = getters => {
  return getters.sessionsList
}

export const getManagingSession = getters => {
  return getters.manageSession
}
